import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { AuthenticationService } from 'src/app/services/firebase/authentication.service';
import { Router } from '@angular/router';
import { MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardSubtitle } from '@angular/material/card';
import { ImageDirective } from '../../../shared/directives/image.directive';
import { MatDivider } from '@angular/material/divider';
import { MatList, MatListItem } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'menu-user, app-menu-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: true,
    imports: [MatCard, MatCardHeader, ImageDirective, MatCardAvatar, MatCardTitle, MatCardSubtitle, MatDivider, MatList, MatListItem, MatIcon]
})
export class UserComponent implements OnInit {
  private auth = inject(AuthService);
  private fba = inject(AuthenticationService);
  private router = inject(Router);



  user: any

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  ngOnInit(): void {
    this.auth.user$.subscribe((response) => {
      this.user = response
    })
  }

  navigate(location) {
    this.router.navigate(location)
  }
  setDark() {
    // Handle dark mode toggle
  }

  signOut() {
    this.fba.signOutUser()
    this.auth.user = undefined // Destroy the authenticated user, this is crude and causes issues. Look into this
  }
}
